// js
import Vue from 'vue';
import VueStripeCheckout from 'vue-stripe-checkout';
import BootstrapVue from '@delmar/bootstrap-vue';
import Number from '@glmaster/vue-number-input';
import Datetime from 'vue-datetime';
import App from './App.vue';
import router from './router';
import Loader from './components/Loader.vue';
import DateTimePicker from './components/DateTimePicker.vue';
import FormFields from './components/FormFields.vue';
import DataSvc from './services/data';
import AppMixin from './services/app-mixin';
import ConfirmDialog from './plugins/confirm-dialog/confirm-dialog';
import WarningDialog from './plugins/warning-dialog/warning-dialog';
import GlobalLoader from './plugins/global-loader/global-loader';
import GlobalToast from './plugins/global-toast/global-toast';
import './directives/select-on-click';
import './directives/select-on-focus';
import './icons';

// css
import './assets/scss/kjk.scss';

Vue.config.productionTip = false;

// plugins
Vue.use(BootstrapVue);
Vue.use(ConfirmDialog);
Vue.use(WarningDialog);
Vue.use(GlobalLoader);
Vue.use(GlobalToast);
Vue.use(Datetime);
Vue.use(VueStripeCheckout, process.env.VUE_APP_STRIPE_PUBLISHABLE_API_KEY);

// components
Vue.component('Loader', Loader);
Vue.component('Number', Number);
Vue.component('DateTimePicker', DateTimePicker);
Vue.component('FormFields', FormFields);

new Vue({
  router,
  render: h => h(App),
  mixins: [AppMixin],
  data: {
    // logged in user
    user: {},

    // organizations
    orgs: [],

    // seasons
    sns: [],

    // timezones
    tzs: {},

    // init
    init: {},
  },
  created() {
    DataSvc.getTimezones()
      .then((timezones) => {
        this.timezones = timezones;
      });
  },
}).$mount('#app');
